export default "__VITE_ASSET__DiGpHm_z__"